import React from 'react'
import { withTranslation } from 'react-i18next'

const ContinueCancelButtons = ({ t, i18n, continueClick, continueText, errorText, cancelClick, showCancel = true }) => {
  const handleCancel = () => {
    if (cancelClick) {
      cancelClick()
      return
    }
    const url = i18n.language === 'en' ? process.env.REACT_APP_PAGE_NOT_FOUND_URL : process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR

    window.location.replace(url)
  }
  return (
    <section className="row">
      <div className="col-auto">
        <button
          className="btn-lg btn-default"
          type="button"
          onClick={continueClick}
          value={t('shared.continue')}
          name={t('shared.continue')}
        >
          {continueText ? t(continueText) : t('shared.continue')}
        </button>
        {errorText && errorText !== '' ? (
          <i
            aria-label={t('shared.error')}
            className="fa fa-exclamation-circle error-indicator ns-error-indicator errorAlert"
            aria-hidden="true"
          ></i>
        ) : null}
      </div>
      {showCancel && (
        <div className="col-auto">
          <button className="btn-lg ns-btn-2nd" type="button" value={t('shared.cancel')} onClick={handleCancel} name={t('shared.cancel')}>
            {t('shared.cancel')}
          </button>
        </div>
      )}
      {errorText && errorText !== '' ? (
        <span id="date-field-error" className="ns--message ns-error-message col-md-12">
          <span className="ns-visually-hidden">{t('shared.error')}</span>
          <strong>{t('shared.before_continuing')}</strong> <span className="ns-error">{t(errorText)}</span>
        </span>
      ) : null}
    </section>
  )
}

export default withTranslation('common')(ContinueCancelButtons)
